import { Box, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useGetJourneyByIdQuery } from "../../store/services/journey-service";
import parseJourneyDataMessage from "../../utils/ParseJourneyDataMessage";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import { ReactComponent as SimulationIcon } from "assets/navigation-icons/simulation.svg";
import { ReactComponent as CourseIcon } from "assets/navigation-icons/course.svg";
import { timelineItemClasses } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import JourneySkeletonComponent from "../../components/Skeleton/JourneySkeletonComponent";

Journeys.propTypes = {
    data: PropTypes.object.isRequired
};

export default function Journeys(props) {
    const { data } = props;

    const { data: journeyData, isLoading } = useGetJourneyByIdQuery(
        { journeyId: data.journeyId },
        { skip: !data.journeyId }
    );

    if (isLoading) {
        return <JourneySkeletonComponent />;
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box>
                    <Typography variant="h4">
                        {data.name} (ID: {data.tenancyId})
                        {data.journeyId ? (
                            <> currently subscribed to&nbsp;
                                <a href={`../journeys/${data.journeyId}`} alt={"Journey link"}>{data.journeyName} </a>
                            </>
                        ) : (
                            " has no legacy journey assigned"
                        )}
                    </Typography>

                    {journeyData && journeyData.journeyOptions && (
                        <Timeline
                            sx={{
                                [`& .${timelineItemClasses.root}:before`]: {
                                    flex: 0,
                                    padding: 0
                                }
                            }}
                        >
                            {[...journeyData.journeyOptions]
                                .sort((a, b) => {
                                    const monthA = Number(a.month);
                                    const monthB = Number(b.month);
                                    const dayA = Number(a.day);
                                    const dayB = Number(b.day);

                                    if (monthA !== monthB) {
                                        return monthA - monthB;
                                    }

                                    if (dayA !== dayB) {
                                        return dayA - dayB;
                                    }

                                    return new Date(a.dateCreated || 0) - new Date(b.dateCreated || 0);
                                })
                                .map((option, index) => {
                                    const { message, isSent } = parseJourneyDataMessage(option, new Date(data.startUserJourneyOn));

                                return (
                                    <TimelineItem key={index}>
                                        <TimelineSeparator>
                                            <TimelineDot
                                                color={(option.type === 1 ? "primary" : "secondary")}
                                                variant={isSent ? "filled" : "outlined"}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "40px",
                                                    height: "40px"
                                                }}
                                            >
                                                {option.type === 1 ? <CourseIcon width="20px" height="20px" /> :
                                                    <SimulationIcon width="20px" height="20px" />}
                                            </TimelineDot>
                                            {index < journeyData.journeyOptions.length - 1 && <TimelineConnector />}
                                        </TimelineSeparator>
                                        <TimelineContent sx={{ py: "12px", px: 2 }}>
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Typography variant="h6">
                                                        {option.type === 0 ? "Simulation" : "Course"}: {option.typeName || option.typeId}
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        {message}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </TimelineContent>
                                    </TimelineItem>
                                );
                            })}
                        </Timeline>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
}
